export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";